import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Building } from '../types/building';
import { DualOccupantState } from '../types/dual-occupant-state';
import { Room } from '../types/room';

const initialState: DualOccupantState = {
    isDualOccupantJourney: null,
    room: null,
    building: null,
    auth0Pin: null,
    vitaRef: null,
    userEmail: null,
};

const DualOccupantSlice = createSlice({
    name: 'dualOccupant',
    initialState,
    reducers: {
        setRoomData: (state: DualOccupantState, action: PayloadAction<Room>) => {
            state.room = action.payload;
        },
        setBuildingData: (state: DualOccupantState, action: PayloadAction<Building>) => {
            state.building = action.payload;
        },
        setQueryData: (
            state: DualOccupantState,
            action: PayloadAction<{ auth0Pin: string; vitaRef: string; userEmail: string }>
        ) => {
            state.vitaRef = action.payload.vitaRef;
            state.auth0Pin = action.payload.auth0Pin;
            state.userEmail = action.payload.userEmail;
        },
        setDualOccupantJourney: (state: DualOccupantState, action: PayloadAction<boolean>) => {
            state.isDualOccupantJourney = action.payload;
        },
    },
});

const selectDualOccupantData = (state: { dualOccupant: DualOccupantState }) => state.dualOccupant;

export default DualOccupantSlice.reducer;

export const { setRoomData, setBuildingData, setQueryData, setDualOccupantJourney } =
    DualOccupantSlice.actions;
export const selectRoom = createSelector(
    [selectDualOccupantData],
    (dualOccupant) => dualOccupant.room
);

export const selectBuilding = createSelector(
    [selectDualOccupantData],
    (booking) => booking.building
);

export const selectQueryData = createSelector([selectDualOccupantData], (dualOccupant) => {
    const { vitaRef, userEmail, auth0Pin } = dualOccupant;
    return {
        vitaRef,
        userEmail,
        auth0Pin,
    };
});

export const selectIsDualOccupantFlow = createSelector([selectDualOccupantData], (dualOccupant) => {
    const { isDualOccupantJourney } = dualOccupant;

    return isDualOccupantJourney || false;
});
